<template>
  <span v-if="(this.$route.name === 'SearchIndex' || this.$route.name === 'ProductsIndex') && hasSearchResults">
      <div  class="sort-btn" @click="showFilter = true;">Sort & Filter</div>

        <div v-show="showFilter" class="sort-filter-wrap">
            <div class="actions">
                <div>
                    <p class="txt-sort">Sort & Filter</p>
                </div>
                <div class="btn-wrap">
                    <p @click="facets.resetFacets()" class="btn btn-reset">Reset</p>
                    <p @click="showFilter = false;" class="btn btn-done">Done</p>
                </div>
            </div>

            <!-- sort by -->
            <div class="sort-by-wrap">
                <div class="flex-space-bet" @click="showSortOption = !showSortOption;">
                    <p class="txt-sort-by txt-black">Sort by</p>
                    <div class="plus-wrap">
                        <img v-if="!showSortOption" class="plus" src="/img/mobile_plus.svg" alt="plus"/>
                        <img v-else class="plus" src="/img/mobile_minus.svg" alt="minus"/>
                    </div>
                </div>
                <p v-if="!showSortOption" class="filter-selected">{{sortBySelected}}</p>

                <div v-if="showSortOption" class="filter-results-wrap">
                    <div class="psb_cb_sec_single">
                        <input type="radio" id="relavent" class="rad-input"
                        :value="'relavent'"
                        v-model="sortIns.sortValue"
                        @change="sortIns.sort"/>
                        <label for="relavent" class="cus-rad-box"></label>
                        <label for="relavent" class="psb_cb_text">Most Relevant</label>
                    </div>
                    <div class="psb_cb_sec_single">
                        <input type="radio" id="price-asc" class="rad-input"
                        :value="'price-asc'"
                        v-model="sortIns.sortValue"
                        @change="sortIns.sort"/>
                        <label for="price-asc" class="cus-rad-box"></label>
                        <label for="price-asc" class="psb_cb_text">Price: Low to High</label>
                    </div>
                    <div class="psb_cb_sec_single">
                        <input type="radio" id="price-desc" class="rad-input"
                        :value="'price-desc'"
                        v-model="sortIns.sortValue"
                        @change="sortIns.sort"/>
                        <label for="price-desc" class="cus-rad-box"></label>
                        <label for="price-desc" class="psb_cb_text">Price: High to Low</label>
                    </div>
                    <div class="psb_cb_sec_single">
                        <input type="radio" id="release_date-desc" class="rad-input"
                        :value="'release_date-desc'"
                        v-model="sortIns.sortValue"
                        @change="sortIns.sort"/>
                        <label for="release_date-desc" class="cus-rad-box"></label>
                        <label for="release_date-desc" class="psb_cb_text">Newest</label>
                    </div>
                </div>
            </div>
            <!-- Categories -->
            <div v-if="facets.categories_ && facets.categories_.length > 0" class="filter-wrap">
                <div @click="toggleFacets('Category')" class="flex-space-bet">
                    <p class="txt-option txt-black">Category</p>
                    <div  class="plus-wrap"><img class="plus" :src="plusOrMinus('Category')" alt="plus"/></div>
                </div>
                <p v-if="!showFacets('Category')" class="filter-selected">{{selectedFacets('categories')}}</p>

                <div class="filter-results-wrap"
                v-if="showFacets('Category')">
                        <div class="psb_cb_sec_single"
                        v-for="(category,index) in facets.categories_" :key="index">
                            <input type="checkbox"  class="psb_cb" 
                                v-model="facets.categories"
                                :value="category.name" 
                                :id="'category_'+category.name">

                            <label class="psb_cb_box"
                                :for="'category_'+category.name"></label>
                            <label class="psb_cb_text"
                                :for="'category_'+category.name">{{category.name}}</label>
                        </div>
                </div>
                
            </div>
            <!-- Filters -->
            <span v-if="Object.keys(facets.filters_|| {}).length">
                <div class="filter-wrap"
                    v-for="(filter,index) in facets.filters_"
                    :key="index"
                    v-show="filter[0].show"
                    >
                    <div @click="toggleFacets(index)" class="flex-space-bet">
                        <p class="txt-option txt-black">{{index}}</p>
                        <div  class="plus-wrap"><img class="plus" :src="plusOrMinus(index)" alt="plus"/></div>
                    </div>
                    <p v-if="!showFacets(index)" class="filter-selected">{{selectedFacets('filters',index)}}</p>

                    <div class="filter-results-wrap"
                    v-if="showFacets(index)">
                            <div class="psb_cb_sec_single"
                            v-for="(item,iindex) in filter"
                            :key="iindex">
                                <input type="checkbox"  class="psb_cb"
                                    v-model="facets.filters"
                                    :value="index + '_' + item.name"
                                    :id="index + '_' + item.name">
                                <label :for="index + '_' + item.name" class="psb_cb_box"></label>
                                <label :for="index + '_' + item.name" class="psb_cb_text">{{item.name}}</label>
                            </div>
                    </div>
                    
                </div>
            </span>
            <!-- Variations -->
            <span v-if="Object.keys(facets.variations_|| {}).length">
                <div class="filter-wrap"
                    v-for="(variation,index) in facets.variations_"
                    :key="index">
                    <div @click="toggleFacets(index)" class="flex-space-bet">
                        <p class="txt-option txt-black">{{index}}</p>
                        <div  class="plus-wrap"><img class="plus" :src="plusOrMinus(index)" alt="plus"/></div>
                    </div>
                    <p v-if="!showFacets(index)" class="filter-selected">{{selectedFacets('variations',index)}}</p>

                    <div class="filter-results-wrap"
                    v-if="showFacets(index)">
                            <div class="psb_cb_sec_single"
                            v-for="(item,iindex) in variation"
                            :key="iindex">
                                <input type="checkbox"  class="psb_cb"
                                    v-model="facets.variations"
                                    :value="index + '_' + item.name"
                                    :id="index + '_' + item.name">
                                <label :for="index + '_' + item.name" class="psb_cb_box"></label>
                                <label :for="index + '_' + item.name" class="psb_cb_text">{{item.name}}</label>
                            </div>
                    </div>        
                </div>
            </span>
             <!-- Vendors -->
            <div class="filter-wrap"
                v-if="facets.vendors_ && facets.vendors_.length > 0 ">
                <div @click="toggleFacets('Brand')" class="flex-space-bet">
                    <p class="txt-option txt-black">Brand</p>
                    <div  class="plus-wrap"><img class="plus" :src="plusOrMinus('Brand')" alt="plus"/></div>
                </div>
                <p v-if="!showFacets('Brand')" class="filter-selected">{{selectedFacets('vendors')}}</p>

                <div class="filter-results-wrap"
                v-if="showFacets('Brand')">
                        <div class="psb_cb_sec_single"
                        v-if="vendor"
                        v-for="(vendor,index) in facets.vendors_" 
                        :key="index">
                            <input type="checkbox"  class="psb_cb"
                            v-model="facets.vendors"
                            :value="vendor.name"
                            :id="'vendor_'+vendor.name">
                            <label :for="'vendor_'+vendor.name" class="psb_cb_box"></label>
                            <label :for="'vendor_'+vendor.name" class="psb_cb_text">{{vendor.name}}</label>
                        </div>
                </div>     
            </div> 
             <!-- Creators -->
            <div class="filter-wrap"
                v-if="facets.creators_ && facets.creators_.length > 0 ">
                <div @click="toggleFacets('Creator')" class="flex-space-bet">
                    <p class="txt-option txt-black">Creator</p>
                    <div  class="plus-wrap"><img class="plus" :src="plusOrMinus('Creator')" alt="plus"/></div>
                </div>
                <p v-if="!showFacets('Creator')" class="filter-selected">{{selectedFacets('creators')}}</p>

                <div class="filter-results-wrap"
                    v-if="showFacets('Creator')"
                >
                        <div class="psb_cb_sec_single"
                        v-if="creator"
                        v-for="(creator,index) in facets.creators_" 
                        :key="index">
                            <input type="checkbox"  class="psb_cb"
                            v-model="facets.creators"
                            :value="creator.name"
                            :id="'vendor_'+creator.name">
                            <label :for="'vendor_'+creator.name" class="psb_cb_box"></label>
                            <label :for="'vendor_'+creator.name" class="psb_cb_text">{{creator.name}}</label>
                        </div>
                </div>     
            </div> 

            <!-- sort by price -->
            <div class="filter-wrap">
                <div @click="showSortByPrice = !showSortByPrice;" class="flex-space-bet">
                    <p class="txt-option txt-black">Price</p>
                    <div class="plus-wrap">
                        <img v-if="!showSortByPrice" class="plus" src="/img/mobile_plus.svg" alt="plus"/>
                        <img v-else class="plus" src="/img/mobile_minus.svg" alt="minus"/>
                    </div>
                </div>

                <p 
                    v-if="!showSortByPrice && (sortByPrice.min || sortByPrice.max)" 
                    class="srt-by-prc-selected"
                >From:<span>{{` $${sortByPrice.min || ''} `}}</span>To:<span>{{` $${sortByPrice.max || ''} `}}</span></p>

                <div v-if="showSortByPrice"  class="filter-results-wrap">
                    <div class="psb_range_sec_inner">
                        <div class="psb_range_single">
                            <div class="psb_range_box">
                                <p class="psb_range_dollar">$</p>
                                <input type="number" class="psb_range_input" min="0" name="number" autocomplete="number"
                                v-model.number="sortByPrice.min">
                            </div>
                            <p class="psb_range_to">to</p>
                            <div class="psb_range_box">
                                <p class="psb_range_dollar">$</p>
                                <input type="number" class="psb_range_input" min="0" name="number" autocomplete="number"
                                v-model.number="sortByPrice.max">
                            </div>
                            <p class="psb_range_go mob-srt-prc-btn" @click="sortByPrice.sortByPrice()">Go</p>
                        </div>
                    </div>
                </div>
                
            </div>

        </div>
</span>

</template>

<script>
import {removeDisturbingElm,addDisturbingElm} from '../../mixins/manageDisturbingElm'
export default {
    data(){
        return{
            showFilter:false,
            facets :{},
            plusImg:'/img/mobile_plus.svg',
            minusImg:'/img/mobile_minus.svg',
            facetsBeingSelected:[],
            sortIns:{},
            sortByPrice:{},
            showSortOption:false,
            hasSearchResults:true,
            showSortByPrice:false
        }
    },
    computed:{

        show(){
            return this.$route.name === 'ProductsIndex' || this.$route.name === 'SearchIndex'
        },

        plusOrMinus(){
            return (facet)=>{
                return this.facetsBeingSelected.indexOf(facet) == -1 ?
                    this.plusImg
                    :this.minusImg
            }
        },

        showFacets(){
            return (facet)=>{
                return this.facetsBeingSelected.indexOf(facet) != -1 
            }
        },

        selectedFacets(){
            return (facet,name = '')=>{
                switch(facet){
                    case 'categories':
                        return this.facets.categories.join()
                        break;
                    case 'filters':
                        return this.facets.filters.filter(s=> s.split('_')[0] == name).map(k=> k.split('_')[1]).join()
                        break;
                    case 'variations':            
                        return this.facets.variations.filter(s=> s.split('_')[0] == name).map(k=> k.split('_')[1]).join()
                        break;
                    case 'vendors':
                        return this.facets.vendors.join()
                        break;
                    case 'creators':
                        return this.facets.creators.join()
                        break
                }
            }
        },

        sortBySelected(){
            switch(this.sortIns.sortValue){
                case 'relavent':
                    return 'Most Relavent'
                    break;
                case 'price-asc':
                    return 'Price: Low to High'
                    break;
                case 'price-desc':
                    return 'Price: High to Low'
                    break;
                case 'release_date-desc':
                    return 'Newest'
                    break
            }
        }
    },

    methods:{
        toggleFacets(facet){
            let i = this.facetsBeingSelected.findIndex(f=> f == facet)
            i == -1 ? 
                this.facetsBeingSelected.push(facet)
                :this.facetsBeingSelected.splice(i,1)
        }
    },

    inject:['componentsComunaction'],

    mounted(){
        this.componentsComunaction.$on('sortMounted',(e)=>{
            this.sortIns = e
            this.sortByPrice = e.sortPrice
        })

        if(this.show){
            this.facets = this.$root.$children.find(com=> com.componentName == 'ProductIndex')
            .$children.find(com=> com.componentName == 'facets')
        } 

        this.componentsComunaction.$on('hasSearchResults',(e)=>{
            this.hasSearchResults = e
        })  
    },

    watch:{
        showFilter(){
            this.showFilter ? removeDisturbingElm(this.$root):addDisturbingElm(this.$root)

            this.facets = this.$root.$children.find(com=> com.componentName == 'ProductIndex')
            .$children.find(com=> com.componentName == 'facets')
        }
    }
}
</script>

<style >
    .sort-btn{
        height: 21px;
        background-color: #FFFFFF;
        border: #F4E2CB solid 1px;
        border-radius:13px;
        display: flex;
        justify-content: center;
        align-items: center ;
        font-size: 15px;
        color: black;
        font-weight: 400;
        cursor: pointer; 
        padding:0px 13px 0px 13px;
    }
    .sort-filter-wrap{
        overflow:scroll;
        position: fixed;
        top:0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #FAF8F5;
        z-index: 100;
        padding-bottom: 60px;
    }
    .actions{
        padding: 16px;
        border-bottom: #F9A73C solid 1px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .txt-sort{
        font-size: 18px;
        font-weight: 500;
        color: black;
    }
    .btn-wrap{
        display: flex;
    }
    .btn{
        cursor: pointer;
        height: 35px;
        width: 79px; 
        border: #016145 solid 1px;
        font-size: 14px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .btn-reset{
        color: #016145;
        margin-right: 10px;
    }
    .btn-done{
        background-color: #016145;
        color: white;
    }
    .sort-by-wrap{
        padding: 19px 16px 19px 16px;
        border-bottom: #F9A73C solid 1px;
    }
    .flex-space-bet{
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .txt-sort-by{
        font-size: 17px;
        font-weight: 500;
    }
    .txt-black{
        color: black;
    }
    .plus-wrap{
        cursor: pointer;
        height: 30px;
        width: 30px;
        display: flex;
        justify-content: center;
        /* align-items: center; */
    }
    .filter-selected,.srt-by-prc-selected span{
        color: #016145;
        font-size: 14px;
        font-weight: 400;
    }
    .srt-by-prc-selected{

    }
    .filter-wrap{
        padding: 0 6px 16px 6px;
        margin: 16px 10px 16px 10px;
        border-bottom: #F4E2CB solid 1px;
    }
    .filter-results-wrap{
        margin-top: 17px;
    }
    .txt-option{
        font-weight: 500;
        font-size: 14px;
    }
    .rad-input{
        opacity: 0;
        height: 0;
        width: 0;
    }
    .cus-rad-box{
        width: 14px;
        height: 14px;
        display: inline-flex;
        border: 1px solid #707070;
        border-radius: 50px;
    }
    .rad-input:checked+.cus-rad-box {
        background-color: rgb(1, 97, 69);
    }

    .mob-srt-prc-btn{
        margin-left: 15px;
    }
</style>


// WEBPACK FOOTER //
// resources/js/components/layouts/MobileSortFilter.vue